export enum analyticsEventType {
  Dashboard = 'Dashboard',
  AccountList = 'Account List',
  AccountDetails = 'Account Details',
  AccountTransactionHistory = 'Account Transaction History',
  AccountTransactionHistoryFilters = 'Account Transaction History Filters',
  AccountEditAlias = 'Edit Alias',
  FundTransferHistoryList = 'Fund Transfer History List',
  FundTransferHistoryFilters = 'Fund Transfer History Filters',
  Profile = 'Profile',
  ProfileChangePhoneOTP = 'Profile Change Phone OTP',
  ProfileChangePhoneSuccess = 'Profile Change Phone Success',
  ProfileChangeEmail = 'Profile Change Email',
  ProfileChangeEmailSuccess = 'Profile Change Email Success',
  FavoriteBeneficiariesList = 'Favorite Beneficiaries List',
  FavoriteBeneficiariesEdit = 'Favorite Beneficiaries Edit',
  FavoriteBeneficiariesCreate = 'Favorite Beneficiaries Create',
  DeviceManagerList = 'Device Manager List',
  Security = 'Security',
  SecurityChangePasswordInput = 'Security Change Password Input',
  SecurityChangePasswordConfirm = 'Security Change Password Confirm',
  SecurityChangePasswordSuccess = 'Security Change Password Success',
  SecurityChangeQuickPinInput = 'Security Change Quick PIN Input',
  SecurityChangeQuickPinConfirmPin = 'Security Change Quick PIN Confirm PIN',
  SecurityChangeQuickPinSuccess = 'Security Change Quick PIN Success',
}

export const pageMapping = (pathname: string): string => {
  if (pathname.includes('dashboard')) {
    return analyticsEventType.Dashboard;
  }
  if (pathname.includes('accounts')) {
    return analyticsEventType.AccountList;
  }
  if (pathname.includes('account') && pathname.includes('details')) {
    return analyticsEventType.AccountDetails;
  }
  if (pathname.includes('account') && pathname.includes('transactions')) {
    return analyticsEventType.AccountTransactionHistory;
  }
  if (pathname.includes('user-profile')) {
    return analyticsEventType.Profile;
  }
  if (pathname.includes('fund-transfer')) {
    return analyticsEventType.FundTransferHistoryList;
  }
  if (pathname.includes('beneficiaries')) {
    return analyticsEventType.FavoriteBeneficiariesList;
  }
  if (pathname.includes('device-management')) {
    return analyticsEventType.DeviceManagerList;
  }
  if (pathname.includes('security-preferences')) {
    return analyticsEventType.Security;
  }
  return '';
};
